import { Button, styled } from "@mui/material";

interface StyledButtonProps {
  isSelected?: boolean;
}

export const StyledSettingsTab = styled(
  ({ ...props }: StyledButtonProps & React.ComponentProps<typeof Button>) => (
    <Button {...props} />
  )
)(({ isSelected, theme }) => ({
  backgroundColor: isSelected ? theme.palette.text.primary : "",
  color: isSelected ? "white" : "black",
  minWidth: "fit-content",
}));
